import styled from "@emotion/styled";
export const StyledDownloadMobileAppComponent = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;

  .download-mobile-app-image {
    width: 168px;
  }
`;
